module.exports = __webpack_public_path__ + "media/images/project/next-week-773bfb03c1bebaca541e1e86646f8b61.svg";